import { parseTrainer } from '../../models/Trainer'
import * as api from '../api'
import useApiMutation from './useApiMutation'

export interface CreateTrainerArguments {
  firstname: string
  lastname: string
  providerUuid?: string | null
  global?: boolean
  username: string
}

export default function useCreateTrainer() {
  return useApiMutation({
    mutationFn: async (data: CreateTrainerArguments) =>
      parseTrainer(
        await api.post('trainer', {
          firstname: data.firstname,
          lastname: data.lastname,
          username: data.username,
          provider_uuid: data.providerUuid,
          global: data.global,
        })
      ),
  })
}
